<form *ngIf="form" class="row" [formGroup]="form">

    <mat-form-field>
        <mat-label>
            Nome
        </mat-label>
        <buffered-input formControlName="nome" textTransform="uppercase"></buffered-input>
    </mat-form-field>
    <mat-form-field>
        <mat-label>
            Cognome
        </mat-label>
        <buffered-input formControlName="cognome" textTransform="uppercase"></buffered-input>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            Via / piazza
        </mat-label>
        <buffered-input formControlName="via" textTransform="capitalize"></buffered-input>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            N. civico
        </mat-label>
        <buffered-input formControlName="civico"></buffered-input>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            Comune
        </mat-label>
        <comune-picker formControlName="comune"></comune-picker>
    </mat-form-field>
    <mat-form-field>
        <mat-label>
            Telefono
        </mat-label>
        <buffered-input formControlName="tel"></buffered-input>
    </mat-form-field>
    <mat-form-field>
        <mat-label>
            Cellulare
        </mat-label>
        <buffered-input formControlName="cell"></buffered-input>
    </mat-form-field>
    <mat-form-field>
        <mat-label>
            Fax
        </mat-label>
        <buffered-input formControlName="fax"></buffered-input>
    </mat-form-field>
    <mat-form-field>
        <mat-label>
            Email
        </mat-label>
        <buffered-input formControlName="email"></buffered-input>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            P. IVA
        </mat-label>
        <buffered-input formControlName="partita_iva"></buffered-input>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            Codice Fiscale
        </mat-label>
        <buffered-input formControlName="codice_fiscale"></buffered-input>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            Tipo
        </mat-label>
        <tipo-altro-soggetto-picker formControlName="tipo"></tipo-altro-soggetto-picker>
    </mat-form-field>
    <mat-form-field matTooltip="Questo campo ricerca nel nome oppure nel cognome in contemporanea">
        <mat-label>
            Denominazione
        </mat-label>
        <buffered-input formControlName="denominazione"></buffered-input>
    </mat-form-field>
</form>
